import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class HeatStartlistRoute extends Route
{
	@service resultsAjax;
	@service store;

	model()
	{
		var event_id = this.modelFor('event').id;
		var store = this.store;

		return this.resultsAjax.request("/events/"+event_id+"/results/individualsSplits").then(function(results)
		{
			results.forEach(function(result)
			{
				if(result.data.relationships.ClassId.data.id != null)
				{
					store.findRecord('class',result.data.relationships.ClassId.data.id);
				}
				else
				{
					delete result.data.relationships.ClassId;
					delete result.data.relationships.ClassGroupId;
				}
				store.pushPayload(result);
			});
		}).then(() =>
		{
			return store.findRecord('Event', event_id);
		});
	}
}
